<div class="flex items-center h-full w-full text-neutral-400">
	<i class="fa-sharp fa-square" [ngClass]="rating() === 'low' || rating() === 'moderate' || rating() === 'high' ? 'fa-solid': 'fa-light'"></i>
	<i class="fa-sharp fa-square" [ngClass]="rating() === 'moderate' || rating() === 'high' ? 'fa-solid': 'fa-light'"></i>
	<i class="fa-sharp fa-square" [ngClass]="rating() === 'high' ? 'fa-solid': 'fa-light'"></i>
</div>